/**
 * Whether `pathname` is one of the headless print-only routes
 * (/print/cotizacion/:id, /print/informe/:id). Used by App.js to bypass
 * Entry's normal `authed`/login gate for these two pages — they
 * authenticate via a `?token=` short-lived JWT instead (see
 * components/Print/PrintGate.js), since they're visited by jag-backend's
 * own isolated Puppeteer browser instance, never a real user's session.
 */
export const isPrintRoute = (pathname) =>
  pathname.startsWith("/print/cotizacion/") ||
  pathname.startsWith("/print/informe/") ||
  pathname.startsWith("/print/cronograma/");
